import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../store/reducers';
import * as rest from '../../services/rest';
import { ISummary } from './types';
import { actions } from './slice';
import { CreateSummaryPayload } from '../../services/rest';

export const createSummaryThunk = createAsyncThunk<ISummary, CreateSummaryPayload>('summaries/createSummaryThunk', async (data, { dispatch, getState }) => {
  const state = getState() as RootState;
  const JWT = state.auth.JWT;
  if (!JWT) throw new Error('No JWT token');

  const summary = await rest.createSummary(JWT, data);
  dispatch(actions.addSummary(summary));
  return summary;
});

/**
 * Fetches a single summary by ID
 * @param summaryId - ID of the summary to fetch
 */
export const getSummaryThunk = createAsyncThunk<ISummary, string>('summaries/getSummaryThunk', async (summaryId, { dispatch, getState }) => {
  const state = getState() as RootState;
  const JWT = state.auth.JWT;
  if (!JWT) throw new Error('No JWT token');

  const summary = await rest.getSummary(JWT, summaryId);
  dispatch(actions.setSelectedSummary(summary));
  return summary;
});

/**
 * Fetches all summaries for an record
 * @param recordId - ID of the record to fetch summaries for
 */
export const getRecordSummariesThunk = createAsyncThunk<ISummary[], string>('summaries/getRecordSummariesThunk', async (recordId, { getState }) => {
  const state = getState() as RootState;
  const JWT = state.auth.JWT;
  if (!JWT) throw new Error('No JWT token');

  return await rest.getRecordSummaries(JWT, recordId);
});

/**
 * Deletes a summary by ID
 * @param summaryId - ID of the summary to delete
 */
export const deleteSummaryThunk = createAsyncThunk<string, string>('summaries/deleteSummary', async (summaryId, { dispatch, getState }) => {
  const state = getState() as RootState;
  const JWT = state.auth.JWT;
  if (!JWT) throw new Error('No JWT token');

  return await rest.deleteSummary(JWT, summaryId);
});
